<template>
  <el-container>
    <el-aside width="200px">
      <SideNav />
    </el-aside>
    <el-main>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"/><!-- :key="$route.fullPath"解决转跳路由到相同组件不刷新问题 -->
    </el-main>
  </el-container>
</template>

<script>
import SideNav from "@/components/SideNav.vue";
export default {
  name: "app",
  components: {
    SideNav,
  },
};
</script>

<style scoped>
.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  /* line-height: 200px; */
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  /* line-height: 160px; */
}
</style>
